import { DirectiveBinding } from 'vue'
export const vSwipe = {
  mounted (el: HTMLElement, binding: DirectiveBinding) {
    let startX = 0
    let endX = 0
    const threshold = 100 // Минимальное смещение пальца для распознавания свайпа

    el.addEventListener('touchstart', handleTouchStart, { passive: true })
    el.addEventListener('touchmove', handleTouchMove)
    el.addEventListener('touchend', handleTouchEnd)

    function handleTouchStart (event: TouchEvent) {
      startX = event.touches[0]?.clientX ?? 0
    }

    function handleTouchMove (event: TouchEvent) {
      endX = event.touches[0]?.clientX ?? 0
    }

    function handleTouchEnd () {
      const diff = endX - startX
      if (diff > threshold) {
        // Свайп влево
        binding.value('left')
      } else if (diff < -threshold) {
        // Свайп вправо
        binding.value('right')
      }
    }
  },
}
